import React from 'react';
import { Wifi, WifiOff, Loader2, AlertTriangle } from '../utils/icons';
import { useWebSocket } from '../contexts/WebSocketContext';

const ConnectionStatusIndicator: React.FC = () => {
  const { connectionStatus, isConnected, lastPing } = useWebSocket();

  const getStatusIcon = () => {
    switch (connectionStatus) {
      case 'connected':
        return <Wifi className="h-4 w-4" />;
      case 'connecting':
        return <Loader2 className="h-4 w-4 animate-spin" />;
      case 'error':
        return <AlertTriangle className="h-4 w-4" />;
      default:
        return <WifiOff className="h-4 w-4" />;
    }
  };

  const getStatusColor = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'text-green-500';
      case 'connecting':
        return 'text-yellow-500';
      case 'error':
        return 'text-red-500';
      default:
        return 'text-gray-400';
    }
  };

  const getStatusText = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'Real-time Connected';
      case 'connecting':
        return 'Connecting...';
      case 'error':
        return 'Connection Error';
      default:
        return 'Offline';
    }
  };

  const timeSinceLastPing = Math.round((Date.now() - lastPing) / 1000);

  return (
    <div
      className="flex items-center space-x-2 text-sm animate-fade-in"
    >
      <div
        className={`${getStatusColor()} ${isConnected ? 'animate-pulse-soft' : ''}`}
      >
        {getStatusIcon()}
      </div>
      
      <div className="flex flex-col">
        <span className={`font-medium ${getStatusColor()}`}>
          {getStatusText()}
        </span>
        {isConnected && (
          <span className="text-xs text-gray-500">
            Last ping: {timeSinceLastPing}s ago
          </span>
        )}
      </div>

      {/* Connection pulse indicator */}
      {isConnected && (
        <div
          className="w-2 h-2 bg-green-500 rounded-full animate-pulse-soft"
        />
      )}
    </div>
  );
};

export default ConnectionStatusIndicator;
